import { Injectable } from '@angular/core';
import { Ng2StateDeclaration } from '@uirouter/angular';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { NotificationsPageComponent } from '@client/app/feature-modules/navigation/notifications/components/notifications-page/notifications-page.component';
import { paginationUrlQueryParamsDeclarations } from '@client/app/shared-modules/state/state-params-declarations/pagination-params-declarations';
import { paginationUrlQueryParamsValidator } from '@client/app/shared-modules/state/state-validators/pagination-url-query-params-validator';
import { removeDomainResolver } from '@client/app/shared-modules/state/state-resolvers/remove-domain-resolver';

@Injectable({ providedIn: 'root' })
export class NotificationsAccessGuard {
    constructor (
        private readonly activeFeatureService: ActiveFeatureService,
        private readonly stateService: StateService,
    ) {}

    checkAccess (transition: Transition): boolean | Promise<unknown> {
        if (this.activeFeatureService.isFeatureActivePure('velaro')) {
            return true;
        }
        const params = transition.params();
        return Promise.resolve(
            this.stateService.go('base.customer.dashboard', { customerId: params['customerId'] as number | string }),
        );
    }
}

export const NotificationsStates: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.notifications',
        url: '/notifications?page&page_size',
        params: {
            ...paginationUrlQueryParamsDeclarations(),
        },
        redirectTo: paginationUrlQueryParamsValidator('base.customer.notifications'),
        resolve: [
            removeDomainResolver(),
            {
                token: 'notificationsAccess',
                deps: [NotificationsAccessGuard, Transition],
                resolveFn: (guard: NotificationsAccessGuard, transition: Transition): boolean | Promise<unknown> =>
                    guard.checkAccess(transition),
            },
        ],
        component: NotificationsPageComponent,
        data: {
            title: 'Acquia Web Governance - Notifications',
            usesModernStyles: true,
        },
    },
];
